import { twMerge } from 'tailwind-merge';

/**
 * Merge class names so conflicting Tailwind utilities resolve predictably
 * (later wins). Required for components like Badge that mix variants with overrides.
 */
export function cn(...classes) {
  return twMerge(classes.filter(Boolean));
}

